<h2 mat-dialog-title data-cy="confirm-dialog-title">{{ title }}</h2>

<mat-dialog-content>
  <p [innerHTML]="message" data-cy="confirm-dialog-description"></p>

  <div fxLayout="row" fxLayoutAlign="start">
    <mat-form-field class="mt-10" fxFlex="100" appearance="legacy">
      <mat-label>{{ inputLabel }}</mat-label>
      <textarea
        autocomplete="off"
        matInput
        matTextareaAutosize
        matAutosizeMinRows="2"
        matAutosizeMaxRows="5"
        [(ngModel)]="inputValue"
        #input="ngModel"
      ></textarea>
    </mat-form-field>
  </div>
</mat-dialog-content>

<mat-dialog-actions fxLayout="row" fxLayoutAlign="end" fxLayoutGap="10px">
  <button mat-button mat-dialog-close cdkFocusInitial data-cy="confirm-dialog-cancel-button">
    <span> {{ cancelText || 'CANCELAR' }} </span>
  </button>

  <button
    class="field-background"
    mat-flat-button
    color="primary"
    (click)="notConfirm()"
    data-cy="confirm-dialog-confirm-button"
  >
    <span> {{ notOkText || 'NÃO ENVIAR' }} </span>
  </button>

  <button
    class="field-background"
    [disabled]="!inputValue || (inputValue && inputValue.length < 10)"
    mat-flat-button
    color="primary"
    (click)="confirm()"
    data-cy="confirm-dialog-confirm-button"
  >
    <span> {{ okText || 'ENVIAR' }} </span>
  </button>
</mat-dialog-actions>
